<ng-container [ngSwitch]="field.type">
  <crm-form-field-autocomplete
    *ngSwitchCase="'autocomplete'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-autocomplete>

  <crm-form-field-text *ngSwitchCase="'text'" [parentFormGroup]="parentFormGroup" [field]="field"></crm-form-field-text>

  <crm-form-field-textarea
    *ngSwitchCase="'textarea'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-textarea>

  <crm-form-field-select
    *ngSwitchCase="'select'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-select>

  <crm-form-field-date *ngSwitchCase="'date'" [parentFormGroup]="parentFormGroup" [field]="field"></crm-form-field-date>

  <crm-local-date-picker
    *ngSwitchCase="'datetime'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-local-date-picker>

  <crm-form-field-datetime-interval
    *ngSwitchCase="'datetime-interval'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-datetime-interval>

  <crm-form-field-date-interval
    *ngSwitchCase="'date-interval'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-date-interval>

  <crm-form-field-checkbox
    *ngSwitchCase="'checkbox'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-checkbox>

  <crm-form-field-number
    *ngSwitchCase="'number'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-number>

  <crm-form-field-radio-button
    *ngSwitchCase="'radio-button'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-radio-button>

  <crm-form-field-file *ngSwitchCase="'file'" [parentFormGroup]="parentFormGroup" [field]="field"></crm-form-field-file>

  <crm-form-field-wysiwyg
    *ngSwitchCase="'wysiwyg'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-wysiwyg>

  <crm-form-field-schedule
    *ngSwitchCase="'schedule'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-schedule>

  <crm-form-field-overbooking-grid
    *ngSwitchCase="'overbooking-grid'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-overbooking-grid>

  <crm-form-field-checkbox-slider
    *ngSwitchCase="'checkbox-slider'"
    [parentFormGroup]="parentFormGroup"
    [field]="field"
  ></crm-form-field-checkbox-slider>
</ng-container>
